import type { Feature } from '@luna/gatekeeper';

export const dynamicCurrencyConversion: Feature = {
    enabled: false,
    _description: 'Enables display of the dynamic currency conversion card and focus page',
};
